export default __webpack_public_path__ + "static/media/fhpCoinInfo.9f4b1d61.jpg";